// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import md5 from 'js-md5' // 加密
import vueAMap from 'vue-amap'
import store from './store/index'
import utils from './util/index'
import './assets/css/base.css'
import Vconsole from 'vconsole' // 调试工具
import mixin from './util/mixin'
import $ from 'jquery'
import 'babel-polyfill'
import LuckDraw from 'vue-luck-draw'
import Meta from 'vue-meta'
// import Address from 'address'



import { Popup, Button, Area, RadioGroup, Radio, Dialog, NavBar, Tabbar, TabbarItem, Search, Tab, Tabs, Swipe, SwipeItem, Lazyload, Grid, GridItem, Row, Col, NoticeBar, Divider, Sidebar, SidebarItem, Rate, GoodsAction, GoodsActionIcon, GoodsActionButton, Sku, CountDown, Icon, Picker, Stepper, Uploader, Step, Steps, Cell, CellGroup, Checkbox, DatetimePicker, CheckboxGroup, DropdownMenu, DropdownItem, IndexBar, IndexAnchor, SwipeCell } from 'vant'
import gComponents from './util/components'

const lazyOptions = {
  loading: require('./assets/image/default.png')
}
Vue.mixin(mixin)
Vue.use(utils.utils)
Vue.use(Popup).use(Button).use(Area).use(RadioGroup).use(Radio).use(Dialog).use(NavBar).use(Tabbar).use(TabbarItem).use(Search).use(Tab).use(Tabs).use(Swipe).use(SwipeItem).use(Lazyload, lazyOptions).use(GridItem).use(Grid).use(Row).use(Col).use(NoticeBar).use(Divider).use(Sidebar).use(SidebarItem).use(Rate).use(GoodsAction).use(GoodsActionIcon).use(GoodsActionButton).use(Sku).use(CountDown).use(Icon).use(Picker).use(Stepper).use(SwipeCell)
Vue.use(gComponents).use(Uploader).use(Step).use(Steps).use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(DatetimePicker).use(DropdownMenu).use(DropdownItem).use(IndexBar).use(IndexAnchor)
Vue.prototype.$md5 = md5
Vue.prototype.$main_color = '#F14547'
Vue.config.productionTip = false
Vue.use(vueAMap)
Vue.use(LuckDraw)
Vue.use(Meta)
// Vue.use(Address)
// 取消这个if注释，可以调出Vconsole调试器，方便测试错误
// if (process.env.NODE_ENV !== 'development') {
//   let vconsole = new Vconsole()
// }
vueAMap.initAMapApiLoader({
  // key: '64f004184ffa1345e687318d205ad50e',
  key: '80ef4d4c5be7bd963a48ab5eb0ec5783',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
    'AMap.PolyEditor', 'AMap.CircleEditor'
  ],
  topWhenClick: true,
  v: '1.4.4'
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
Vue.component('remote-script', {
  render: function (createElement) {
    var self = this;
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: this.src
      },
      on: {
        load: function (event) {
          self.$emit('load', event);
        },
        error: function (event) {
          self.$emit('error', event);
        },
        readystatechange: function (event) {
          if (this.readyState == 'complete') {
            self.$emit('load', event);
          }
        }
      }
    });
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
})




// WEBPACK FOOTER //
// ./src/main.js